module.exports = __webpack_public_path__ + "img/reception 2.8d7b61d8.jpeg";